import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-sm-8" }
const _hoisted_8 = { class: "navbar-nav overflow-auto flex-row gap-4 pt-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle ms-1 mt-1"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "form-group col-sm-8 mt-1"
}
const _hoisted_13 = { class: "navbar-nav overflow-auto flex-row gap-4 pt-1" }
const _hoisted_14 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_15 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_16 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_17 = {
  key: 1,
  class: "form-group col-sm-8 mt-1"
}
const _hoisted_18 = { class: "navbar-nav overflow-auto flex-row gap-4 pt-1" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle ms-1 mt-1"
}
const _hoisted_21 = { class: "form-group col-sm-4 d-flex align-items-center justify-content-end" }
const _hoisted_22 = {
  key: 0,
  class: "form-check form-switch me-2"
}
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_25 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_26 = { class: "col p-0" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_29 = { class: "col p-0" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_32 = { class: "col p-0" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_36 = { class: "col p-0" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_40 = { class: "col p-0" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = {
  key: 0,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2 d-flex"
}
const _hoisted_43 = { class: "col p-0 d-flex align-items-center" }
const _hoisted_44 = { class: "form-check small mb-0" }
const _hoisted_45 = {
  class: "form-check-label",
  for: "roundedToTakerSum"
}
const _hoisted_46 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_47 = { class: "col p-0" }
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_50 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_51 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_52 = { class: "col p-0" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = {
  key: 1,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2 d-flex"
}
const _hoisted_55 = { class: "col p-0 d-flex align-items-center" }
const _hoisted_56 = { class: "form-check small mb-0" }
const _hoisted_57 = {
  class: "form-check-label",
  for: "onlyMir"
}
const _hoisted_58 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_59 = { class: "col p-0" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_62 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_63 = { class: "col p-0" }
const _hoisted_64 = { class: "" }
const _hoisted_65 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_66 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_67 = { class: "col p-0" }
const _hoisted_68 = { class: "" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-4" }
const _hoisted_71 = { class: "col p-0" }
const _hoisted_72 = { class: "" }
const _hoisted_73 = {
  key: 2,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_74 = { class: "col p-0" }
const _hoisted_75 = { class: "" }
const _hoisted_76 = {
  key: 3,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_77 = { class: "col p-0" }
const _hoisted_78 = { class: "" }
const _hoisted_79 = {
  key: 4,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_80 = { class: "col p-0" }
const _hoisted_81 = { class: "" }
const _hoisted_82 = {
  key: 5,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_83 = { class: "col p-0" }
const _hoisted_84 = { class: "" }
const _hoisted_85 = {
  key: 6,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_86 = { class: "col p-0" }
const _hoisted_87 = { class: "" }
const _hoisted_88 = ["placeholder"]
const _hoisted_89 = {
  key: 7,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_90 = { class: "col p-0" }
const _hoisted_91 = { class: "form-check small mb-0 mt-1" }
const _hoisted_92 = {
  class: "form-check-label",
  for: "hasDisputeRequest"
}
const _hoisted_93 = {
  key: 8,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_94 = { class: "col p-0" }
const _hoisted_95 = { class: "form-check small mb-0 mt-1" }
const _hoisted_96 = {
  class: "form-check-label",
  for: "disputePaused"
}
const _hoisted_97 = { class: "form-group mb-2 col" }
const _hoisted_98 = { class: "col-auto p-0 text-end" }
const _hoisted_99 = { class: "col-sm-12" }
const _hoisted_100 = { class: "card card-body" }
const _hoisted_101 = { class: "overflow-auto" }
const _hoisted_102 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_103 = { class: "text-capitalize-first" }
const _hoisted_104 = { class: "text-capitalize-first" }
const _hoisted_105 = { class: "text-capitalize-first" }
const _hoisted_106 = { class: "text-capitalize-first" }
const _hoisted_107 = { class: "text-capitalize-first" }
const _hoisted_108 = { class: "text-capitalize-first" }
const _hoisted_109 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_110 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_111 = { class: "pe-0" }
const _hoisted_112 = ["title"]
const _hoisted_113 = ["title"]
const _hoisted_114 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = ["title"]
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = ["title"]
const _hoisted_120 = { key: 1 }
const _hoisted_121 = ["title"]
const _hoisted_122 = {
  key: 2,
  class: "text-secondary"
}
const _hoisted_123 = ["title"]
const _hoisted_124 = { key: 0 }
const _hoisted_125 = ["title"]
const _hoisted_126 = {
  key: 3,
  class: "text-secondary"
}
const _hoisted_127 = ["title"]
const _hoisted_128 = { class: "text-secondary" }
const _hoisted_129 = {
  key: 0,
  class: "fa fa-pause-circle text-warning me-1"
}
const _hoisted_130 = {
  key: 1,
  class: "text-nowrap text-capitalize"
}
const _hoisted_131 = {
  key: 2,
  class: "text-nowrap text-capitalize"
}
const _hoisted_132 = ["href"]
const _hoisted_133 = ["href"]
const _hoisted_134 = {
  key: 0,
  class: "me-2"
}
const _hoisted_135 = ["disabled", "title", "onClick"]
const _hoisted_136 = {
  key: 2,
  class: "text-danger me-2"
}
const _hoisted_137 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_138 = { class: "text-lowercase" }
const _hoisted_139 = {
  key: 2,
  class: "text-lowercase text-danger"
}
const _hoisted_140 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_141 = {
  key: 4,
  class: "mt-1"
}
const _hoisted_142 = { class: "text-secondary" }
const _hoisted_143 = ["title"]
const _hoisted_144 = {
  key: 5,
  class: "mt-1"
}
const _hoisted_145 = { class: "text-secondary" }
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "text-lowercase text-primary" }
const _hoisted_148 = { class: "text-secondary" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = { key: 0 }
const _hoisted_151 = {
  key: 2,
  class: "small text-secondary"
}
const _hoisted_152 = { key: 4 }
const _hoisted_153 = { class: "text-danger" }
const _hoisted_154 = { key: 5 }
const _hoisted_155 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_156 = ["title"]
const _hoisted_157 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_158 = ["href"]
const _hoisted_159 = {
  key: 6,
  class: "mt-1 small"
}
const _hoisted_160 = { key: 0 }
const _hoisted_161 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_162 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_163 = { key: 1 }
const _hoisted_164 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_165 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_166 = { class: "d-flex flex-column" }
const _hoisted_167 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_168 = { class: "d-flex flex-column" }
const _hoisted_169 = { class: "d-flex gap-1" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { key: 2 }
const _hoisted_173 = {
  key: 3,
  style: {"line-height":"10px"},
  class: "badge bg-primary"
}
const _hoisted_174 = { key: 0 }
const _hoisted_175 = { class: "text-secondary text-wrap" }
const _hoisted_176 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_177 = { key: 0 }
const _hoisted_178 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_179 = { key: 2 }
const _hoisted_180 = ["href"]
const _hoisted_181 = ["href"]
const _hoisted_182 = ["href"]
const _hoisted_183 = ["href"]
const _hoisted_184 = ["href"]
const _hoisted_185 = { key: 5 }
const _hoisted_186 = { key: 3 }
const _hoisted_187 = { class: "text-secondary text-capitalize-first me-2" }
const _hoisted_188 = {
  key: 4,
  class: "text-secondary"
}
const _hoisted_189 = {
  key: 5,
  class: "text-secondary"
}
const _hoisted_190 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_191 = ["title"]
const _hoisted_192 = { class: "justify-content-center d-flex position-absolute w-100" }
const _hoisted_193 = { key: 1 }
const _hoisted_194 = ["title"]
const _hoisted_195 = { key: 0 }
const _hoisted_196 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_197 = { key: 0 }
const _hoisted_198 = { class: "d-flex flex-column" }
const _hoisted_199 = { class: "d-flex align-items-center" }
const _hoisted_200 = ["title"]
const _hoisted_201 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_202 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_203 = { key: 1 }
const _hoisted_204 = { class: "d-flex flex-row" }
const _hoisted_205 = { class: "text-secondary me-1" }
const _hoisted_206 = { class: "d-flex flex-row" }
const _hoisted_207 = { class: "text-secondary me-1" }
const _hoisted_208 = {
  key: 2,
  class: "text-end"
}
const _hoisted_209 = ["onClick"]
const _hoisted_210 = ["onClick"]
const _hoisted_211 = ["onClick"]
const _hoisted_212 = ["onClick"]
const _hoisted_213 = ["onClick"]
const _hoisted_214 = ["onClick", "disabled", "title"]
const _hoisted_215 = {
  key: 3,
  class: "text-end"
}
const _hoisted_216 = ["onClick"]
const _hoisted_217 = ["onClick"]
const _hoisted_218 = ["onClick"]
const _hoisted_219 = ["onClick"]
const _hoisted_220 = ["onClick"]
const _hoisted_221 = ["onClick"]
const _hoisted_222 = ["onClick"]
const _hoisted_223 = ["onClick"]
const _hoisted_224 = ["onClick"]
const _hoisted_225 = ["onClick", "disabled", "title"]
const _hoisted_226 = ["href"]
const _hoisted_227 = {
  key: 4,
  class: "text-end"
}
const _hoisted_228 = ["onClick"]
const _hoisted_229 = ["onClick"]
const _hoisted_230 = ["onClick"]
const _hoisted_231 = ["onClick"]
const _hoisted_232 = ["onClick", "disabled", "title"]
const _hoisted_233 = ["href"]
const _hoisted_234 = {
  key: 5,
  class: "text-end"
}
const _hoisted_235 = ["onClick"]
const _hoisted_236 = ["title", "onClick"]
const _hoisted_237 = ["onClick"]
const _hoisted_238 = ["onClick"]
const _hoisted_239 = ["onClick"]
const _hoisted_240 = ["onClick"]
const _hoisted_241 = ["onClick"]
const _hoisted_242 = ["onClick"]
const _hoisted_243 = ["onClick", "disabled", "title"]
const _hoisted_244 = ["href"]
const _hoisted_245 = {
  key: 6,
  class: "text-end"
}
const _hoisted_246 = { class: "row mb-2" }
const _hoisted_247 = { class: "col-sm-12" }
const _hoisted_248 = { class: "row mt-2" }
const _hoisted_249 = {
  for: "from_sum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_250 = { class: "col-sm-8" }
const _hoisted_251 = { class: "row mt-2" }
const _hoisted_252 = {
  for: "to_sum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_253 = { class: "col-sm-8" }
const _hoisted_254 = { class: "row mt-2" }
const _hoisted_255 = {
  for: "pay-out-currencies",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_256 = { class: "col-sm-8" }
const _hoisted_257 = { class: "row mt-2" }
const _hoisted_258 = {
  class: "col-sm-4 col-form-label text-capitalize-first",
  for: "pay-out-roundedToTakerSum"
}
const _hoisted_259 = { class: "col-sm-8" }
const _hoisted_260 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_261 = { class: "row mt-2" }
const _hoisted_262 = {
  for: "pay-out-methods",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_263 = { class: "col-sm-8" }
const _hoisted_264 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_265 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_266 = { class: "row mt-2" }
const _hoisted_267 = {
  for: "pay-out-options",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_268 = { class: "col-sm-8" }
const _hoisted_269 = { class: "row mt-2" }
const _hoisted_270 = {
  for: "pay-out-onlyMir",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_271 = { class: "col-sm-8" }
const _hoisted_272 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_273 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_274 = {
  for: "maxActiveDealCount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_275 = { class: "col-sm-8" }
const _hoisted_276 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_TraderPayoutLimitBanner = _resolveComponent("TraderPayoutLimitBanner")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_ReceiptCheckStatus = _resolveComponent("ReceiptCheckStatus")!
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!
  const _component_DeviceLabel = _resolveComponent("DeviceLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_TradeDealDetailsTable = _resolveComponent("TradeDealDetailsTable")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_DeviceMessageLogs = _resolveComponent("DeviceMessageLogs")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_DealConfirmModal = _resolveComponent("DealConfirmModal")!
  const _component_DisputeConfirmModal = _resolveComponent("DisputeConfirmModal")!
  const _component_PayoutConfirmModal = _resolveComponent("PayoutConfirmModal")!
  const _component_OperatorDealConfirmModal = _resolveComponent("OperatorDealConfirmModal")!
  const _component_SuspendDealModal = _resolveComponent("SuspendDealModal")!
  const _component_AssignTraderToDealModal = _resolveComponent("AssignTraderToDealModal")!
  const _component_ChangeDealAmountModal = _resolveComponent("ChangeDealAmountModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (statuses, tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          (tab === 'dispute')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.onTabSelect(tab)), ["prevent"]),
                                class: _normalizeClass(["nav-link tab text-capitalize-first position-relative", {'active': _ctx.activeTabName === tab}])
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans(`deals.tab.${tab}`)) + " ", 1),
                                (_ctx.newDisputeDealsCountOut > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_9))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.onTabSelect(tab)), ["prevent"]),
                                class: _normalizeClass(["nav-link tab text-capitalize-first", {'active': _ctx.activeTabName === tab}])
                              }, _toDisplayString(_ctx.helper.trans(`deals.tab.${tab}`)), 11, _hoisted_11))
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.activeTabName === 'dispute' && (_ctx.isAdmin || _ctx.isOperator))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("ul", _hoisted_13, [
                          _createElementVNode("li", _hoisted_14, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onDisputeRoleSelect(null)), ["prevent"])),
                              class: _normalizeClass(["nav-link tab text-capitalize-first", {'active': _ctx.activeDisputeTab === null}])
                            }, _toDisplayString(_ctx.helper.trans('labels.all')), 3)
                          ]),
                          _createElementVNode("li", _hoisted_15, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onDisputeRoleSelect('Trader')), ["prevent"])),
                              class: _normalizeClass(["nav-link tab text-capitalize-first", {'active': _ctx.activeDisputeTab === 'Trader'}])
                            }, _toDisplayString(_ctx.helper.trans('deals.tab.disputeTrader')), 3)
                          ]),
                          _createElementVNode("li", _hoisted_16, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onDisputeRoleSelect('Provider')), ["prevent"])),
                              class: _normalizeClass(["nav-link tab text-capitalize-first", {'active': _ctx.activeDisputeTab === 'Provider'}])
                            }, _toDisplayString(_ctx.helper.trans('deals.tab.disputeProvider')), 3)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("ul", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeTabs, (tab) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: tab,
                              class: _normalizeClass([{'d-none': tab === _ctx.Direction.PAY_OUT && (_ctx.isTrader && _ctx.user.pcId)}, "nav-item nav-item-spaced d-flex text-nowrap"])
                            }, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.onTypeSelect(tab)), ["prevent"]),
                                class: _normalizeClass(["nav-link tab text-capitalize-first position-relative", {'active': _ctx.activeTypeName === tab}])
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans(`direction.${tab}`)) + " ", 1),
                                (tab === _ctx.Direction.PAY_IN && _ctx.newActiveDealsCountIn > 0 || tab === _ctx.Direction.PAY_OUT && _ctx.newActiveDealsCountOut > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_19),
                              (tab === _ctx.Direction.PAY_OUT && (_ctx.isTrader && !_ctx.user.pcId || _ctx.isTraderOperator))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showPayoutSettings && _ctx.showPayoutSettings(...args)), ["prevent"])),
                                    class: "ms-3 text-secondary",
                                    href: "#"
                                  }, _cache[53] || (_cache[53] = [
                                    _createElementVNode("i", { class: "fa fa-gear" }, null, -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.activeTabName === 'active' && _ctx.isTrader)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "autoRefreshToggle",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.autoRefresh) = $event)),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleAutoRefresh && _ctx.toggleAutoRefresh(...args))),
                            title: `${_ctx.helper.trans(_ctx.autoRefresh ? 'labels.auto_refresh.on' : 'labels.auto_refresh.off')}`
                          }, null, 40, _hoisted_23), [
                            [_vModelCheckbox, _ctx.autoRefresh],
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              {
                                hover: true,
                                left: true
                              }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.toggleFiltersVisibility()), ["prevent"])),
                      class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                    }, _toDisplayString(_ctx.helper.trans('button.filters')), 1)
                  ])
                ]),
                (_ctx.showFilters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[7] || (_cache[7] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: "ID",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.id) = $event))
                            }, null, 544), [
                              [_vModelText, _ctx.requestDTO.id]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_Multiselect, {
                              id: "types",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.types,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                              options: Object.values(_ctx.Direction),
                              "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.type')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[10] || (_cache[10] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: _ctx.helper.trans('labels.from_sum'),
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestDTO.fromTakerSum) = $event))
                            }, null, 40, _hoisted_34), [
                              [_vModelText, _ctx.requestDTO.fromTakerSum]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[12] || (_cache[12] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: _ctx.helper.trans('labels.to_sum'),
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestDTO.toTakerSum) = $event))
                            }, null, 40, _hoisted_38), [
                              [_vModelText, _ctx.requestDTO.toTakerSum]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_Multiselect, {
                              id: "currencies",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.currencies,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                              options: _ctx.currencyList,
                              "custom-label": (opt) => `${opt}`,
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.currencies')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTrader && !_ctx.user.pcId) || _ctx.isTraderOperator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestDTO.roundedToTakerSum) = $event)),
                                  "true-value": "1000",
                                  type: "checkbox",
                                  value: "",
                                  id: "roundedToTakerSum"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.requestDTO.roundedToTakerSum]
                                ]),
                                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.rounded_to_1000')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_Multiselect, {
                              id: "methods",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.methods,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                              options: _ctx.methodList(),
                              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.payment_methods')
                            }, {
                              option: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_PayMethodIcon, {
                                    "icon-class": "icon",
                                    method: props.option
                                  }, null, 8, ["method"]),
                                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_Multiselect, {
                              id: "options",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.options,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                              options: _ctx.store.getters['currencyMethods/options'](),
                              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.payment_options')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTrader && !_ctx.user.pcId) || _ctx.isTraderOperator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.requestDTO.onlyMir) = $event)),
                                  "true-value": "y",
                                  type: "checkbox",
                                  value: "",
                                  id: "onlyMir"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.requestDTO.onlyMir]
                                ]),
                                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.helper.trans('labels.only_mir_cards')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_DatePicker, {
                              modelValue: _ctx.requestDTO.fromDate,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                              mode: "dateTime",
                              "model-modifiers": {string: true},
                              is24hr: "",
                              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                            }, {
                              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                                _createElementVNode("input", {
                                  class: "form-control form-control-sm",
                                  placeholder: _ctx.helper.trans('labels.from_date'),
                                  value: inputValue,
                                  onFocus: togglePopover,
                                  onChange: inputEvents.change
                                }, null, 40, _hoisted_61)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_DatePicker, {
                              modelValue: _ctx.requestDTO.toDate,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                              mode: "dateTime",
                              "model-modifiers": {string: true},
                              is24hr: "",
                              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                            }, {
                              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                                _createElementVNode("input", {
                                  class: "form-control form-control-sm",
                                  placeholder: _ctx.helper.trans('labels.to_date'),
                                  value: inputValue,
                                  onFocus: togglePopover,
                                  onChange: inputEvents.change
                                }, null, 40, _hoisted_65)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[21] || (_cache[21] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: _ctx.helper.trans('labels.customer_id'),
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.requestDTO.takerId) = $event))
                            }, null, 40, _hoisted_69), [
                              [_vModelText, _ctx.requestDTO.takerId]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_Multiselect, {
                              id: "statuses",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.statuses,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                              options: Object.values(_ctx.DealStatus),
                              "custom-label": (opt) => _ctx.helper.trans(`deal_status.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.statuses')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      (_ctx.isOperator || _ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _createVNode(_component_TraderMultiselect, {
                                  "onUpdate:modelValue": [
                                    _ctx.onTraderListUpdate,
                                    _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tradersFilter) = $event))
                                  ],
                                  multiple: true,
                                  modelValue: _ctx.tradersFilter
                                }, null, 8, ["onUpdate:modelValue", "modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isReferral && (!_ctx.user.pcId))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createVNode(_component_DevicesMultiselect, {
                                  ref: "deviceMultiselect",
                                  multiple: true,
                                  "trader-ids": _ctx.tradersFilter.map((item) => item.id),
                                  modelValue: _ctx.devicesFilter,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.devicesFilter) = $event))
                                }, null, 8, ["trader-ids", "modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOperator || _ctx.isAdmin || _ctx.isReferral)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                _createVNode(_component_StoreMultiselect, {
                                  multiple: true,
                                  modelValue: _ctx.storesFilter,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.storesFilter) = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createVNode(_component_TrafficGroupMultiselect, {
                                  multiple: true,
                                  small: "",
                                  modelValue: _ctx.trafficGroupsFilter,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.isAdmin || _ctx.isOperator))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control form-control-sm",
                                  onKeydown: _cache[28] || (_cache[28] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                                  placeholder: _ctx.helper.trans('labels.sanitized_requisite'),
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.requestDTO.requisites) = $event))
                                }, null, 40, _hoisted_88), [
                                  [_vModelText, _ctx.requestDTO.requisites]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isReferral && (!_ctx.user.pcId))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.requestDTO.hasDisputeRequest) = $event)),
                                  "true-value": "y",
                                  type: "checkbox",
                                  value: "",
                                  id: "hasDisputeRequest"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.requestDTO.hasDisputeRequest]
                                ]),
                                _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.helper.trans('labels.has_dispute')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.isAdmin || _ctx.isOperator) && _ctx.activeTabName === 'dispute')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.requestDTO.disputePaused) = $event)),
                                  "true-value": "y",
                                  type: "checkbox",
                                  value: "",
                                  id: "disputePaused"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.requestDTO.disputePaused]
                                ]),
                                _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.helper.trans('labels.dispute_paused')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[32] || (_cache[32] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                            class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[33] || (_cache[33] = _withModifiers(() => _ctx.onTabSelect('active'), ["prevent"])),
                            class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.currentType === _ctx.Direction.PAY_OUT && _ctx.payoutLimit)
              ? (_openBlock(), _createBlock(_component_TraderPayoutLimitBanner, {
                  key: 0,
                  limit: _ctx.payoutLimit
                }, null, 8, ["limit"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("table", _hoisted_102, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[54] || (_cache[54] = _createElementVNode("th", {
                          class: "text-capitalize-first",
                          style: {"width":"0"}
                        }, null, -1)),
                        _createElementVNode("th", _hoisted_103, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.id_date')) + " ", 1),
                          (_ctx.activeTabName === 'dispute' && (_ctx.isOperator || _ctx.isAdmin))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'createdAt'); _ctx.loadDeals()}, ["prevent"]))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'createdAt')])
                                }, null, 2)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("th", _hoisted_104, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.status')) + " ", 1),
                          (_ctx.activeTabName === 'dispute' && (_ctx.isOperator || _ctx.isAdmin))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'updatedAt'); _ctx.loadDeals()}, ["prevent"]))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'updatedAt')])
                                }, null, 2)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("th", _hoisted_105, _toDisplayString(_ctx.helper.trans(_ctx.showStoreRate ? 'labels.trader_rate_merchant_rate' : 'labels.rate')), 1),
                        _createElementVNode("th", _hoisted_106, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                        _createElementVNode("th", _hoisted_107, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                        _cache[55] || (_cache[55] = _createElementVNode("th", { style: {"width":"0"} }, null, -1)),
                        _createElementVNode("th", _hoisted_108, _toDisplayString(_ctx.helper.trans('labels.time_spent_create_deal')), 1),
                        (_ctx.isOperator || _ctx.isAdmin || _ctx.isTeamLead)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_109, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isOperator || _ctx.isAdmin || _ctx.isReferral)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_110, _toDisplayString(_ctx.helper.trans('labels.store')), 1))
                          : _createCommentVNode("", true),
                        _cache[56] || (_cache[56] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeals, (deal) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: deal.id,
                          class: ""
                        }, [
                          _createElementVNode("td", _hoisted_111, [
                            (deal.type === _ctx.Direction.PAY_IN)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  title: _ctx.helper.trans(`direction.${deal.type}`),
                                  class: "fa-regular fa-circle-down text-primary"
                                }, null, 8, _hoisted_112)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  title: _ctx.helper.trans(`direction.${deal.type}`),
                                  class: "fa-regular fa-circle-up text-warning"
                                }, null, 8, _hoisted_113)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_114, [
                              (_ctx.isProvider)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_115, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      title: deal.id
                                    }, [
                                      _createTextVNode(_toDisplayString(deal.id.substring(0, 8)), 1)
                                    ], 8, _hoisted_116)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ]),
                                    _cache[57] || (_cache[57] = _createTextVNode()),
                                    _createVNode(_component_copy_button, {
                                      value: deal.id
                                    }, null, 8, ["value"])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_117, [
                                    (deal.status !== 'rejected')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_118, [
                                          _withDirectives((_openBlock(), _createElementBlock("span", {
                                            title: deal.publicId
                                          }, [
                                            _createTextVNode(_toDisplayString(deal.publicId), 1)
                                          ], 8, _hoisted_119)), [
                                            [
                                              _directive_b_tooltip,
                                              void 0,
                                              void 0,
                                              { hover: true }
                                            ]
                                          ]),
                                          _cache[58] || (_cache[58] = _createTextVNode()),
                                          _createVNode(_component_copy_button, {
                                            value: deal.publicId
                                          }, null, 8, ["value"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    ((_ctx.isAdmin || _ctx.isOperator) && deal.id != deal.invoiceId)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                                          _cache[59] || (_cache[59] = _createTextVNode(" / ")),
                                          _withDirectives((_openBlock(), _createElementBlock("span", {
                                            title: deal.id
                                          }, [
                                            _createTextVNode(_toDisplayString(deal.id.substring(0, 8)), 1)
                                          ], 8, _hoisted_121)), [
                                            [
                                              _directive_b_tooltip,
                                              void 0,
                                              void 0,
                                              { hover: true }
                                            ]
                                          ]),
                                          _cache[60] || (_cache[60] = _createTextVNode()),
                                          _createVNode(_component_copy_button, {
                                            value: deal.id
                                          }, null, 8, ["value"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])),
                              (_ctx.isAdmin || _ctx.isOperator)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_122, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      title: deal.invoiceId
                                    }, [
                                      _createTextVNode(_toDisplayString(deal.invoiceId.substring(0, 8)), 1)
                                    ], 8, _hoisted_123)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ]),
                                    _cache[63] || (_cache[63] = _createTextVNode()),
                                    _createVNode(_component_copy_button, {
                                      value: deal.invoiceId
                                    }, null, 8, ["value"]),
                                    (deal.invoiceInternalId)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                                          _cache[61] || (_cache[61] = _createTextVNode(" / ")),
                                          _withDirectives((_openBlock(), _createElementBlock("span", {
                                            title: deal.invoiceInternalId
                                          }, [
                                            _createTextVNode(_toDisplayString(deal.invoiceInternalId.substring(0, 8)), 1)
                                          ], 8, _hoisted_125)), [
                                            [
                                              _directive_b_tooltip,
                                              void 0,
                                              void 0,
                                              { hover: true }
                                            ]
                                          ]),
                                          _cache[62] || (_cache[62] = _createTextVNode()),
                                          _createVNode(_component_copy_button, {
                                            value: deal.invoiceInternalId
                                          }, null, 8, ["value"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.aggregatorExternalId && (_ctx.isAdmin || _ctx.isOperator || _ctx.isProvider))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_126, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      title: deal.aggregatorExternalId
                                    }, [
                                      _createTextVNode(_toDisplayString(deal.aggregatorExternalId.substring(0, 8)), 1)
                                    ], 8, _hoisted_127)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ]),
                                    _cache[64] || (_cache[64] = _createTextVNode()),
                                    _createVNode(_component_copy_button, {
                                      value: deal.aggregatorExternalId
                                    }, null, 8, ["value"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("small", _hoisted_128, _toDisplayString(_ctx.dateHelper.format(deal.createdAt)), 1)
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: _normalizeClass({'text-primary': deal.status === _ctx.DealStatus.TRANSFER_CONFIRMED})
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", null, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans(`deal_status.${deal.status}`)) + " ", 1),
                                (deal.isDisputeAutocompletingSuspend)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_129))
                                  : _createCommentVNode("", true),
                                ([_ctx.DealStatus.NEW, _ctx.DealStatus.TRANSFER_CONFIRMED, _ctx.DealStatus.TRANSFER_WAITING].includes(deal.status))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_130, [
                                      _cache[65] || (_cache[65] = _createElementVNode("i", { class: "fa fa-stopwatch" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getFormattedCancelTime(deal)), 1)
                                    ]))
                                  : (deal.disputeAutocloseAt && _ctx.DealStatus.DISPUTE === deal.status)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_131, [
                                        _cache[66] || (_cache[66] = _createElementVNode("i", { class: "fa fa-stopwatch" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getFormattedDisputeAutocloseTime(deal)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                (deal.disputeAttachment)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 3,
                                      href: `${_ctx.api.baseUrl()}/attachments/${deal.disputeAttachment}`,
                                      target: "_blank",
                                      type: "button",
                                      class: "me-2 text-warning"
                                    }, _cache[67] || (_cache[67] = [
                                      _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                                    ]), 8, _hoisted_132))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deal.attachments, (attachment) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: attachment.id
                                  }, [
                                    _createElementVNode("a", {
                                      href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                                      target: "_blank",
                                      type: "button",
                                      class: "me-2 text-warning"
                                    }, _cache[68] || (_cache[68] = [
                                      _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                                    ]), 8, _hoisted_133),
                                    (_ctx.chequeCheckerEnabled && _ctx.receiptVerdict(deal, attachment.id))
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_134, _toDisplayString(_ctx.receiptVerdict(deal, attachment.id)), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.canCheckReceipt && _ctx.isPdfAttachment(attachment.file))
                                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-sm btn-outline-secondary text-nowrap me-2",
                                          disabled: _ctx.isReceiptCheckPending(deal, attachment.id),
                                          title: _ctx.receiptCheckTooltip(deal, attachment.id),
                                          onClick: _withModifiers(($event: any) => (_ctx.checkReceipt(deal, attachment.id)), ["prevent"])
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.helper.trans('button.check_receipt')), 1)
                                        ], 8, _hoisted_135)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            { hover: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true),
                                    (_ctx.receiptCheckError(deal, attachment.id))
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_136, _toDisplayString(_ctx.receiptCheckError(deal, attachment.id)), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ]),
                              (deal.disputeReason === _ctx.DisputeReason.INVALID_SUM || deal.disputeReason === _ctx.DisputeReason.PART_PAYOUT)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_137, [
                                    _cache[69] || (_cache[69] = _createTextVNode(" (")),
                                    _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.helper.trans(`dispute_reason.${deal.disputeReason}`)), 1),
                                    _createTextVNode(": " + _toDisplayString(_ctx.numberFormatter.formatNumber(deal.disputeReasonData.amount, 2)) + " " + _toDisplayString(deal.takerSum.currency) + ") ", 1)
                                  ]))
                                : (_ctx.isPayOutReceiptCheck(deal.type, deal.disputeReason))
                                  ? (_openBlock(), _createBlock(_component_ReceiptCheckStatus, {
                                      key: 1,
                                      reason: deal.disputeReason,
                                      data: deal.disputeReasonData
                                    }, null, 8, ["reason", "data"]))
                                  : (deal.disputeReason)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_139, " (" + _toDisplayString(_ctx.helper.trans(`dispute_reason.${deal.disputeReason}`)) + ") ", 1))
                                    : _createCommentVNode("", true),
                              (deal._insufficientSumForDisputeClose)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                    _createElementVNode("small", null, [
                                      _cache[70] || (_cache[70] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.insufficientSumForDisputeClose')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.transactionId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                    _createElementVNode("small", _hoisted_142, [
                                      _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.transaction')) + ": ", 1),
                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                        title: deal.transactionId
                                      }, [
                                        _createTextVNode(_toDisplayString(deal.transactionId.length > 8 ? deal.transactionId.substring(0, 4) + '...' + deal.transactionId.substring(deal.transactionId.length - 4) : deal.transactionId), 1)
                                      ], 8, _hoisted_143)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ]),
                                      _cache[71] || (_cache[71] = _createTextVNode()),
                                      _createVNode(_component_copy_button, {
                                        value: deal.transactionId
                                      }, null, 8, ["value"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.externalNspkTransaction)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                    _createElementVNode("small", _hoisted_145, _toDisplayString(deal.externalNspkTransaction?.service) + ": " + _toDisplayString(deal.externalNspkTransaction?.status), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (deal.disputeResult)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                  _createElementVNode("small", _hoisted_147, _toDisplayString(_ctx.helper.trans(`dispute_result.${deal.disputeResult}`)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", _hoisted_148, _toDisplayString(_ctx.dateHelper.format(deal.updatedAt)), 1)
                            ])
                          ], 2),
                          _createElementVNode("td", null, [
                            (deal.status !== 'rejected')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_149, [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatNumber(deal.takerSum.amount / deal.makerSum.amount, deal.takerSum.subunit)), 1),
                                  (deal.merchantMakerSum)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" / " + _toDisplayString(_ctx.numberFormatter.formatNumber(deal.takerSum.amount / deal.merchantMakerSum.amount, deal.takerSum.subunit)), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(deal.takerSum.currency), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (deal.actualTakerSum)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.actualTakerSum)) + " ", 1),
                                    _createVNode(_component_copy_button, {
                                      value: deal.actualTakerSum.amount
                                    }, null, 8, ["value"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (!deal.actualTakerSum || deal.isActualSumsChanged)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass({'text-decoration-line-through': deal.isActualSumsChanged})
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.takerSum)) + " ", 1),
                                  _createVNode(_component_copy_button, {
                                    value: deal.takerSum.amount
                                  }, null, 8, ["value"])
                                ], 2))
                              : _createCommentVNode("", true),
                            (deal.actualMakerSum)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.actualMakerSum)) + " ", 1),
                                  _createVNode(_component_copy_button, {
                                    value: deal.actualMakerSum.amount
                                  }, null, 8, ["value"])
                                ]))
                              : _createCommentVNode("", true),
                            (deal.status !== 'rejected' && (!deal.actualMakerSum || deal.isActualSumsChanged))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: _normalizeClass(["small text-secondary", {'text-decoration-line-through': deal.isActualSumsChanged}])
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.makerSum)) + " ", 1),
                                  _createVNode(_component_copy_button, {
                                    value: deal.makerSum.amount
                                  }, null, 8, ["value"])
                                ], 2))
                              : _createCommentVNode("", true),
                            (deal.strictlySingleTransfer === true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                  _createElementVNode("small", _hoisted_153, [
                                    _cache[72] || (_cache[72] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.strictly_single_transfer')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (deal.type === _ctx.Direction.PAY_OUT && !_ctx.hidePayoutSupportedMethods)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                  (!_ctx.payOutDocLink)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_155, [
                                        _cache[73] || (_cache[73] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.pay_out_supported_methods_sources_start')) + " ", 1),
                                        _withDirectives((_openBlock(), _createElementBlock("span", {
                                          style: {"border-bottom":"1px dashed"},
                                          title: _ctx.payOutSupportedMethodsSources.map((method) => _ctx.helper.trans(`pay_methods.${method}`)).join(', ')
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.pay_out_supported_methods_sources_end', {count: _ctx.payOutSupportedMethodsSources.length})), 1)
                                        ], 8, _hoisted_156)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            { hover: true }
                                          ]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("small", _hoisted_157, [
                                        _cache[74] || (_cache[74] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                        _cache[75] || (_cache[75] = _createTextVNode()),
                                        _createElementVNode("a", {
                                          href: _ctx.payOutDocLink,
                                          class: "text-danger",
                                          target: "_blank"
                                        }, _toDisplayString(_ctx.helper.trans('labels.pay_out_supported_methods_doc_link')), 9, _hoisted_158)
                                      ]))
                                ]))
                              : _createCommentVNode("", true),
                            (deal.minTakerSum && deal.maxTakerSum || deal.minInTakerSum && deal.maxInTakerSum)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                  (deal.minTakerSum && deal.maxTakerSum)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                        (deal.minTakerSum?.amount !== deal.maxTakerSum?.amount)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_161, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minTakerSum)) + " - " + _toDisplayString(_ctx.numberFormatter.formatMoney(deal.maxTakerSum)), 1))
                                          : (_openBlock(), _createElementBlock("small", _hoisted_162, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minTakerSum)), 1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (deal.minInTakerSum && deal.maxInTakerSum)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                        (deal.minInTakerSum?.amount !== deal.maxInTakerSum?.amount)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_164, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minInTakerSum)) + " - " + _toDisplayString(_ctx.numberFormatter.formatMoney(deal.maxInTakerSum)), 1))
                                          : (_openBlock(), _createElementBlock("small", _hoisted_165, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minInTakerSum)), 1))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("div", _hoisted_167, [
                                _createVNode(_component_PayMethodIcon, {
                                  method: deal.paymentMethod
                                }, null, 8, ["method"]),
                                _createElementVNode("div", _hoisted_168, [
                                  _createElementVNode("small", _hoisted_169, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + deal.paymentOption)), 1),
                                    (deal.requisites?.crossBorderCurrency)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_170, _toDisplayString(deal.requisites?.crossBorderCurrency), 1))
                                      : _createCommentVNode("", true),
                                    (deal.requisites?.paymentSystem)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_171, _toDisplayString(_ctx.helper.trans('payment_systems.' + deal.requisites?.paymentSystem)), 1))
                                      : _createCommentVNode("", true),
                                    (deal.requisites?.p2cConfig?.service_name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(_ctx.helper.trans(`multitransfer.service.${deal.requisites?.p2cConfig?.service_name}`)), 1))
                                      : _createCommentVNode("", true),
                                    (deal.matchingPayoutDeal)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_173, "Matching"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (deal.type === _ctx.Direction.PAY_OUT && deal.status === _ctx.DealStatus.NEW)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                        _createElementVNode("small", _hoisted_175, _toDisplayString(_ctx.helper.trans('labels.accept_deal_to_show_req')), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                        ((deal.type === _ctx.Direction.PAY_OUT && deal.paymentOption === _ctx.PaymentOption.TO_CARD) || deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_177, [
                                              _createTextVNode(_toDisplayString(deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()) + " ", 1),
                                              _createVNode(_component_copy_button, {
                                                value: deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()
                                              }, null, 8, ["value"])
                                            ]))
                                          : (deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && !_ctx.helper.dealQrCodeLink(deal))
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_178, _toDisplayString(_ctx.helper.trans('labels.manual_sbp_qr_awaiting_link')), 1))
                                            : (!_ctx.helper.isEmvQrOption(deal.paymentOption) && (!!deal.paymentRequisites.requisites || (deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(deal))))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_179, [
                                                  (deal.paymentOption === _ctx.PaymentOption.SBP_QR && deal.paymentRequisites.requisites?.startsWith('http'))
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: deal.paymentRequisites.requisites,
                                                        target: "_blank"
                                                      }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_180))
                                                    : (deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(deal))
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 1,
                                                          href: _ctx.helper.dealQrCodeLink(deal),
                                                          target: "_blank"
                                                        }, _toDisplayString(_ctx.helper.domain(_ctx.helper.dealQrCodeLink(deal))), 9, _hoisted_181))
                                                      : (deal.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && deal.paymentRequisites.requisites?.startsWith('http'))
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 2,
                                                            href: deal.paymentRequisites.requisites,
                                                            target: "_blank"
                                                          }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_182))
                                                        : (deal.paymentOption === _ctx.PaymentOption.TIPS && deal.paymentRequisites.requisites?.startsWith('http'))
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 3,
                                                              href: deal.paymentRequisites.requisites,
                                                              target: "_blank"
                                                            }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_183))
                                                          : (deal.paymentRequisites.requisites?.startsWith('http'))
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 4,
                                                                href: deal.paymentRequisites.requisites,
                                                                target: "_blank"
                                                              }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_184))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_185, _toDisplayString(deal.paymentRequisites.requisites), 1)),
                                                  _createVNode(_component_copy_button, {
                                                    value: deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(deal) ? _ctx.helper.dealQrCodeLink(deal) : deal.paymentRequisites.requisites,
                                                    class: "ms-1"
                                                  }, null, 8, ["value"])
                                                ]))
                                              : _createCommentVNode("", true),
                                        (_ctx.helper.isEmvQrOption(deal.paymentOption))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_186, [
                                              _createElementVNode("small", _hoisted_187, _toDisplayString(_ctx.helper.trans('labels.raw_field.qrString')), 1),
                                              _createVNode(_component_copy_button, {
                                                value: _ctx.helper.emvQrData(deal)
                                              }, null, 8, ["value"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (deal.paymentOption === _ctx.PaymentOption.SBP_QR && deal.requisites && !deal.requisites.requisites.startsWith('http'))
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_188, _toDisplayString(deal.requisites.requisites), 1))
                                          : (_openBlock(), _createElementBlock("small", _hoisted_189, _toDisplayString(deal.paymentRequisites.holder), 1))
                                      ]))
                                ])
                              ]),
                              (deal.matchingPayoutDeal && deal.type === _ctx.Direction.PAY_OUT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                    _createElementVNode("div", null, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                        class: "mb-2",
                                        title: _ctx.helper.trans('labels.day')
                                      }, [
                                        _createVNode(_component_b_progress, {
                                          max: parseInt(deal.matchingPayoutDeal.dealsSumLimit.amount),
                                          class: "progress-bar-striped position-relative"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_b_progress_bar, {
                                              value: parseInt(deal.matchingPayoutDeal.dealsSum.amount),
                                              class: "progress-bar-striped bg-secondary-light position-absolute h-100"
                                            }, null, 8, ["value"]),
                                            _createVNode(_component_b_progress_bar, {
                                              value: parseInt(deal.matchingPayoutDeal.completedDealsSum.amount),
                                              class: "progress-bar-striped bg-primary position-absolute h-100"
                                            }, null, 8, ["value"]),
                                            _createElementVNode("small", _hoisted_192, _toDisplayString(_ctx.numberFormatter.formatNumber(deal.matchingPayoutDeal?.completedDealsSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(deal.matchingPayoutDeal?.dealsSumLimit)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["max"])
                                      ], 8, _hoisted_191)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.matchingPayoutDeal && deal.type === _ctx.Direction.PAY_IN)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans(`direction.out`)) + ":", 1),
                                    _cache[76] || (_cache[76] = _createTextVNode()),
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      title: deal.matchingPayoutDeal.dealId
                                    }, [
                                      _createTextVNode(_toDisplayString(deal.matchingPayoutDeal.dealId.substring(0, 8)), 1)
                                    ], 8, _hoisted_194)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ]),
                                    _cache[77] || (_cache[77] = _createTextVNode()),
                                    _createVNode(_component_copy_button, {
                                      value: deal.matchingPayoutDeal.dealId
                                    }, null, 8, ["value"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (deal.type === _ctx.Direction.PAY_IN && deal._device)
                              ? (_openBlock(), _createBlock(_component_DeviceLabel, {
                                  key: 0,
                                  "show-id": _ctx.isOperator || _ctx.isAdmin,
                                  device: deal._device,
                                  "onDevice:updated": _ctx.onDeviceUpdated
                                }, null, 8, ["show-id", "device", "onDevice:updated"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (deal.timeSpentCreateDeal != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_195, _toDisplayString(_ctx.numberFormatter.formatNumber(deal.timeSpentCreateDeal, 3)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_196, "—"))
                          ]),
                          (_ctx.isOperator || _ctx.isAdmin || _ctx.isTeamLead)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_197, [
                                _createElementVNode("div", _hoisted_198, [
                                  _createElementVNode("div", _hoisted_199, [
                                    _createElementVNode("span", null, _toDisplayString(deal.traderName), 1),
                                    (_ctx.providersByTraderId[deal.traderId])
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          title: _ctx.helper.trans('labels.provider'),
                                          class: "badge bg-warning ms-1"
                                        }, _cache[78] || (_cache[78] = [
                                          _createTextVNode("P")
                                        ]), 8, _hoisted_200)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            { hover: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.isOperator || _ctx.isAdmin)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_201, [
                                        _createTextVNode(_toDisplayString(deal.traderId ?? 'n/a') + " ", 1),
                                        (deal.traderId)
                                          ? (_openBlock(), _createBlock(_component_copy_button, {
                                              key: 0,
                                              value: deal.traderId.toString()
                                            }, null, 8, ["value"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.providersByTraderId[deal.traderId]?.supportApiDisputes)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_202, [
                                        _cache[79] || (_cache[79] = _createElementVNode("i", { class: "fa fa-circle-info" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.api_disputes')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isOperator || _ctx.isAdmin || _ctx.isReferral)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_203, [
                                _createElementVNode("div", _hoisted_204, [
                                  _createElementVNode("small", _hoisted_205, [
                                    _createTextVNode(_toDisplayString(deal.merchantId ?? 'n/a') + " ", 1),
                                    (deal.merchantId)
                                      ? (_openBlock(), _createBlock(_component_copy_button, {
                                          key: 0,
                                          value: deal.merchantId.toString()
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(deal.merchantName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_206, [
                                  _createElementVNode("small", _hoisted_207, [
                                    _createTextVNode(_toDisplayString(deal.storeId ?? 'n/a') + " ", 1),
                                    (deal.storeId)
                                      ? (_openBlock(), _createBlock(_component_copy_button, {
                                          key: 0,
                                          value: deal.storeId.toString()
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(deal.storeName), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.isTrader || _ctx.isTraderOperator) && deal.type === _ctx.Direction.PAY_OUT )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_208, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.detailsDeal = deal),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _cache[80] || (_cache[80] = [
                                  _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                                ]), 8, _hoisted_209),
                                (deal.status === _ctx.DealStatus.TRANSFER_WAITING || deal.status === _ctx.DealStatus.DISPUTE)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'refuse')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[81] || (_cache[81] = _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.refuse')), 1)
                                    ], 8, _hoisted_210))
                                  : _createCommentVNode("", true),
                                (_ctx.canShowActiveDealDisputeButton(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'dispute')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[82] || (_cache[82] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.open_dispute')), 1)
                                    ], 8, _hoisted_211))
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.NEW && !_ctx.isExpired(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'accept')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[83] || (_cache[83] = _createElementVNode("i", { class: "fa fa-stopwatch" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getFormattedCancelTime(deal)) + " " + _toDisplayString(_ctx.helper.trans('button.accept')), 1)
                                    ], 8, _hoisted_212))
                                  : _createCommentVNode("", true),
                                (_ctx.user.isPayoutConfirmationFromWebAppAllowed && (deal.status === _ctx.DealStatus.TRANSFER_WAITING || deal.status === _ctx.DealStatus.DISPUTE))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'confirm_payout')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[84] || (_cache[84] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.confirm_transfer')), 1)
                                    ], 8, _hoisted_213))
                                  : _createCommentVNode("", true),
                                (deal.isVideoRequestAvailable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                      key: 4,
                                      onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                      disabled: _ctx.isVideoRequested(deal),
                                      title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[85] || (_cache[85] = _createElementVNode("i", { class: "fa fa-video" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.helper.trans('button.video_requested') : _ctx.helper.trans('button.request_video')), 1)
                                    ], 8, _hoisted_214)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.isOperator || _ctx.isAdmin) && deal.type === _ctx.Direction.PAY_OUT)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_215, [
                                ((_ctx.isAdmin || (_ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.REDIRECT_PAYOUTS))) && deal.status === _ctx.DealStatus.DISPUTE)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.assignTrader(deal)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                    }, _cache[86] || (_cache[86] = [
                                      _createElementVNode("i", { class: "fa-solid fa-user-pen" }, null, -1)
                                    ]), 8, _hoisted_216))
                                  : _createCommentVNode("", true),
                                ((_ctx.isAdmin || (_ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.REDIRECT_PAYOUTS))) && deal.status === _ctx.DealStatus.NEW && deal.traderId === null)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.assignByUnassigned(deal)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                    }, _cache[87] || (_cache[87] = [
                                      _createElementVNode("i", { class: "fa-solid fa-user-pen" }, null, -1)
                                    ]), 8, _hoisted_217))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.detailsDeal = deal),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _cache[88] || (_cache[88] = [
                                  _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                                ]), 8, _hoisted_218),
                                (deal.status === _ctx.DealStatus.NEW && deal.traderId !== null && !_ctx.isExpired(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'accept')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[89] || (_cache[89] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.accept')), 1)
                                    ], 8, _hoisted_219))
                                  : _createCommentVNode("", true),
                                ([_ctx.DealStatus.NEW, _ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.DISPUTE].includes(deal.status))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'cancel')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[90] || (_cache[90] = _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
                                    ], 8, _hoisted_220))
                                  : _createCommentVNode("", true),
                                (_ctx.canShowActiveDealDisputeButton(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 4,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'dispute')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[91] || (_cache[91] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.open_dispute')), 1)
                                    ], 8, _hoisted_221))
                                  : _createCommentVNode("", true),
                                (_ctx.canChangePayOutAmount(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 5,
                                      onClick: _withModifiers(($event: any) => (_ctx.showChangeAmount(deal)), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-primary text-nowrap text-capitalize"
                                    }, [
                                      _cache[92] || (_cache[92] = _createElementVNode("i", { class: "fa fa-pen" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.change_payout_amount')), 1)
                                    ], 8, _hoisted_222))
                                  : _createCommentVNode("", true),
                                ([_ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.DISPUTE].includes(deal.status))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 6,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'confirm')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[93] || (_cache[93] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.confirm_transfer')), 1)
                                    ], 8, _hoisted_223))
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.CANCELED || deal.status === _ctx.DealStatus.COMPLETED)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 7,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'dispute')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[94] || (_cache[94] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.open_dispute')), 1)
                                    ], 8, _hoisted_224))
                                  : _createCommentVNode("", true),
                                (deal.isVideoRequestAvailable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                      key: 8,
                                      onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                      disabled: _ctx.isVideoRequested(deal),
                                      title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[95] || (_cache[95] = _createElementVNode("i", { class: "fa fa-video" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.helper.trans('button.video_requested') : _ctx.helper.trans('button.request_video')), 1)
                                    ], 8, _hoisted_225)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.DISPUTE && deal.disputeAttachment !== null)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 9,
                                      href: `${_ctx.api.baseUrl()}/attachments/${deal.disputeAttachment}`,
                                      target: "_blank",
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap"
                                    }, _cache[96] || (_cache[96] = [
                                      _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                                    ]), 8, _hoisted_226))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.isTrader || _ctx.isTraderOperator) && deal.type === _ctx.Direction.PAY_IN )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_227, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.detailsDeal = deal),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _cache[97] || (_cache[97] = [
                                  _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                                ]), 8, _hoisted_228),
                                (deal.status === _ctx.DealStatus.NEW)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'accept')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[98] || (_cache[98] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.accept')), 1)
                                    ], 8, _hoisted_229))
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.NEW)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'cancel')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[99] || (_cache[99] = _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
                                    ], 8, _hoisted_230))
                                  : _createCommentVNode("", true),
                                ([_ctx.DealStatus.DISPUTE, _ctx.DealStatus.TRANSFER_CONFIRMED, _ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.CANCELED].includes(deal.status))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'confirm')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[100] || (_cache[100] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.confirm_transfer')), 1)
                                    ], 8, _hoisted_231))
                                  : _createCommentVNode("", true),
                                (deal.isVideoRequestAvailable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                      disabled: _ctx.isVideoRequested(deal),
                                      title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[101] || (_cache[101] = _createElementVNode("i", { class: "fa fa-video" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.helper.trans('button.video_requested') : _ctx.helper.trans('button.request_video')), 1)
                                    ], 8, _hoisted_232)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.DISPUTE && deal.disputeAttachment !== null)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 4,
                                      href: `${_ctx.api.baseUrl()}/attachments/${deal.disputeAttachment}`,
                                      target: "_blank",
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap"
                                    }, _cache[102] || (_cache[102] = [
                                      _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                                    ]), 8, _hoisted_233))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.isOperator || _ctx.isAdmin) && deal.type === _ctx.Direction.PAY_IN)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_234, [
                                (deal.status === _ctx.DealStatus.DISPUTE && deal.isDisputeAutocompletingSuspend !== true)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.showSuspendDealModal(deal)),
                                      class: "btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2"
                                    }, _cache[103] || (_cache[103] = [
                                      _createElementVNode("i", { class: "fa fa-pause-circle" }, null, -1)
                                    ]), 8, _hoisted_235))
                                  : (deal.status === _ctx.DealStatus.DISPUTE && deal.isDisputeAutocompletingSuspend === true)
                                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        title: _ctx.getSuspendDisputeTitle(deal),
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.dealAutocompleting(deal, 'resume')),
                                        class: "btn btn-sm btn-outline-success text-nowrap text-capitalize me-2"
                                      }, _cache[104] || (_cache[104] = [
                                        _createElementVNode("i", { class: "fa fa-play-circle" }, null, -1)
                                      ]), 8, _hoisted_236)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ])
                                    : _createCommentVNode("", true),
                                (deal.deviceId)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.showMessageLogs(deal)),
                                      class: "btn btn-sm btn-outline-secondary text-nowrap me-2"
                                    }, _cache[105] || (_cache[105] = [
                                      _createElementVNode("i", { class: "fa fa-mobile-screen-button" }, null, -1),
                                      _createTextVNode(),
                                      _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)
                                    ]), 8, _hoisted_237))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.detailsDeal = deal),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _cache[106] || (_cache[106] = [
                                  _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                                ]), 8, _hoisted_238),
                                (deal.status === _ctx.DealStatus.DISPUTE || ([_ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.TRANSFER_CONFIRMED].includes(deal.status) && _ctx.enableOperatorPayInCancelTransferWaiting))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'cancel')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[107] || (_cache[107] = _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
                                    ], 8, _hoisted_239))
                                  : _createCommentVNode("", true),
                                (_ctx.canShowActiveDealDisputeButton(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 4,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'dispute')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[108] || (_cache[108] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.open_dispute')), 1)
                                    ], 8, _hoisted_240))
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.DISPUTE || ([_ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.TRANSFER_CONFIRMED].includes(deal.status) && _ctx.enableOperatorPayInConfirmTransferWaiting))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 5,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'confirm')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"
                                    }, [
                                      _cache[109] || (_cache[109] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.confirm_transfer')), 1)
                                    ], 8, _hoisted_241))
                                  : _createCommentVNode("", true),
                                (_ctx.canShowPayInDisputeButton(deal))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 6,
                                      onClick: _withModifiers(($event: any) => (_ctx.changeStatus(deal, 'dispute')), ["prevent"]),
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[110] || (_cache[110] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.open_dispute')), 1)
                                    ], 8, _hoisted_242))
                                  : _createCommentVNode("", true),
                                (deal.isVideoRequestAvailable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                      key: 7,
                                      onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                      disabled: _ctx.isVideoRequested(deal),
                                      title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                    }, [
                                      _cache[111] || (_cache[111] = _createElementVNode("i", { class: "fa fa-video" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.helper.trans('button.video_requested') : _ctx.helper.trans('button.request_video')), 1)
                                    ], 8, _hoisted_243)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (deal.status === _ctx.DealStatus.DISPUTE && deal.disputeAttachment !== null)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 8,
                                      href: `${_ctx.api.baseUrl()}/attachments/${deal.disputeAttachment}`,
                                      target: "_blank",
                                      type: "button",
                                      class: "me-2 btn btn-sm btn-outline-secondary text-nowrap"
                                    }, _cache[112] || (_cache[112] = [
                                      _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                                    ]), 8, _hoisted_244))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isReferral || _ctx.isTeamLead)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_245))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.deals.totalCount > _ctx.deals.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[36] || (_cache[36] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[37] || (_cache[37] = ($event: any) => (_ctx.loadDeals()))
                        ],
                        "total-rows": _ctx.deals.totalCount,
                        "per-page": _ctx.deals.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "last-number": "",
                        "hide-goto-end-buttons": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_b_modal, {
          title: "",
          "dialog-class": "modal-lg",
          modelValue: _ctx.detailsDeal !== null,
          "footer-class": "d-flex justify-content-end",
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ($event === false && (_ctx.detailsDeal = null)))
        }, {
          default: _withCtx(() => [
            (_ctx.detailsDeal)
              ? (_openBlock(), _createBlock(_component_TradeDealDetailsTable, {
                  key: 0,
                  deal: _ctx.detailsDeal,
                  onManualSbpQrUpdated: _ctx.onManualSbpQrDealDetailsUpdated
                }, null, 8, ["deal", "onManualSbpQrUpdated"]))
              : _createCommentVNode("", true)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.detailsDeal = null), ["prevent"])),
              class: "btn btn-outline-dark btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_b_modal, {
          title: _ctx.helper.trans('labels.message_logs', {'device_name': _ctx.logsModalDevice?.name}),
          "dialog-class": "modal-xl",
          modelValue: _ctx.logsModalDevice !== null,
          "footer-class": "d-flex justify-content-end",
          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ($event === false && (_ctx.logsModalDevice = null)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DeviceMessageLogs, {
              "from-date": _ctx.logsModalDates.fromDate,
              "to-date": _ctx.logsModalDates.toDate,
              device: _ctx.logsModalDevice!
            }, null, 8, ["from-date", "to-date", "device"])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.logsModalDevice = null), ["prevent"])),
              class: "btn btn-outline-dark btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
          ]),
          _: 1
        }, 8, ["title", "modelValue"]),
        _createVNode(_component_b_modal, {
          title: "",
          "dialog-class": "modal-lg",
          modelValue: _ctx.payOutSettingsModal,
          "footer-class": "d-flex justify-content-end",
          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.payOutSettingsModal = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LoaderWrapper, { ref: "payOutSettingsModalLoader" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_246, [
                  _createElementVNode("div", _hoisted_247, [
                    _createElementVNode("div", _hoisted_248, [
                      _createElementVNode("label", _hoisted_249, _toDisplayString(_ctx.helper.trans("labels.from_sum")), 1),
                      _createElementVNode("div", _hoisted_250, [
                        _createVNode(_component_FormInputWrapper, null, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.payOutSettings.minAmount) = $event)),
                              type: "text",
                              id: "from_sum"
                            }, null, 2), [
                              [_vModelText, _ctx.payOutSettings.minAmount]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_251, [
                      _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.helper.trans("labels.to_sum")), 1),
                      _createElementVNode("div", _hoisted_253, [
                        _createVNode(_component_FormInputWrapper, null, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.payOutSettings.maxAmount) = $event)),
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              type: "text",
                              id: "to_sum"
                            }, null, 2), [
                              [_vModelText, _ctx.payOutSettings.maxAmount]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_254, [
                      _createElementVNode("label", _hoisted_255, _toDisplayString(_ctx.helper.trans("labels.currencies")), 1),
                      _createElementVNode("div", _hoisted_256, [
                        _createVNode(_component_FormInputWrapper, null, {
                          default: _withCtx((parentProps) => [
                            _createVNode(_component_Multiselect, {
                              id: "pay-out-currencies",
                              class: "multiselect-sm",
                              modelValue: _ctx.payOutSettings.currencies,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.payOutSettings.currencies) = $event)),
                              options: _ctx.currencyList,
                              "custom-label": (opt) => `${opt}`,
                              multiple: true,
                              "select-label": "Select"
                            }, null, 8, ["modelValue", "options", "custom-label"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_257, [
                      _createElementVNode("label", _hoisted_258, _toDisplayString(_ctx.helper.trans('labels.rounded_to_1000')), 1),
                      _createElementVNode("div", _hoisted_259, [
                        _createElementVNode("div", _hoisted_260, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.payOutSettings.multiplesOfValue1000) = $event)),
                            type: "checkbox",
                            id: "pay-out-roundedToTakerSum"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.payOutSettings.multiplesOfValue1000]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_261, [
                      _createElementVNode("label", _hoisted_262, _toDisplayString(_ctx.helper.trans("labels.payment_methods")), 1),
                      _createElementVNode("div", _hoisted_263, [
                        _createVNode(_component_FormInputWrapper, null, {
                          default: _withCtx((parentProps) => [
                            _createVNode(_component_Multiselect, {
                              id: "pay-out-methods",
                              class: "multiselect-sm",
                              modelValue: _ctx.payOutSettings.paymentMethods,
                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.payOutSettings.paymentMethods) = $event)),
                              options: _ctx.methodList(),
                              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              readonly: !_ctx.isAdmin
                            }, {
                              option: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_264, [
                                  _createVNode(_component_PayMethodIcon, {
                                    "icon-class": "icon",
                                    method: props.option
                                  }, null, 8, ["method"]),
                                  _createElementVNode("span", _hoisted_265, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "custom-label", "readonly"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_266, [
                      _createElementVNode("label", _hoisted_267, _toDisplayString(_ctx.helper.trans("labels.payment_options")), 1),
                      _createElementVNode("div", _hoisted_268, [
                        _createVNode(_component_FormInputWrapper, null, {
                          default: _withCtx((parentProps) => [
                            _createVNode(_component_Multiselect, {
                              id: "pay-out-options",
                              class: "multiselect-sm",
                              modelValue: _ctx.payOutSettings.paymentOptions,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.payOutSettings.paymentOptions) = $event)),
                              options: _ctx.store.getters['currencyMethods/options'](),
                              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              readonly: !_ctx.isAdmin
                            }, null, 8, ["modelValue", "options", "custom-label", "readonly"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_269, [
                      _createElementVNode("label", _hoisted_270, _toDisplayString(_ctx.helper.trans("labels.only_mir_cards")), 1),
                      _createElementVNode("div", _hoisted_271, [
                        _createElementVNode("div", _hoisted_272, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.payOutSettings.onlyMir) = $event)),
                            "true-value": true,
                            type: "checkbox",
                            value: "",
                            id: "pay-out-onlyMir"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.payOutSettings.onlyMir]
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                          _createElementVNode("label", _hoisted_274, _toDisplayString(_ctx.helper.trans("labels.max_active_deals_count")), 1),
                          _createElementVNode("div", _hoisted_275, [
                            _createElementVNode("div", _hoisted_276, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control form-control-sm",
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.payOutSettings.maxActiveDealsCount) = $event)),
                                id: "maxActiveDealCount"
                              }, null, 512), [
                                [_vModelText, _ctx.payOutSettings.maxActiveDealsCount]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 512)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.payOutSettingsModal = false), ["prevent"])),
              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.savePayoutSettings()), ["prevent"])),
              class: "btn btn-outline-primary btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
        _createVNode(_component_DealConfirmModal, { ref: "dealConfirmModal" }, null, 512),
        _createVNode(_component_DisputeConfirmModal, { ref: "disputeConfirmModal" }, null, 512),
        _createVNode(_component_PayoutConfirmModal, { ref: "payoutConfirmModal" }, null, 512),
        _createVNode(_component_OperatorDealConfirmModal, { ref: "operatorDealConfirmModal" }, null, 512),
        _createVNode(_component_SuspendDealModal, { ref: "suspendDealModal" }, null, 512),
        _createVNode(_component_AssignTraderToDealModal, { ref: "assignTraderToDealModal" }, null, 512),
        _createVNode(_component_ChangeDealAmountModal, { ref: "changeDealAmountModal" }, null, 512)
      ])
    ]),
    _: 1
  }, 512))
}